import { appContextGuard } from './core/guards/app-context.guard';
import { AppRoutes } from './shared/app.models';

export const routes: AppRoutes = [
  {
    path: 'error',
    loadComponent: () => import('./shared/errors/error-page/error-page').then((m) => m.ErrorPage),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./shared/errors/not-found-page/not-found-page').then((m) => m.NotFoundPage),
  },
  {
    path: 'server-error',
    loadComponent: () =>
      import('./shared/errors/server-error-page/server-error-page').then((m) => m.ServerErrorPage),
  },

  {
    path: '',
    canActivate: [appContextGuard],
    loadComponent: () => import('./layout/main-layout/main-layout').then((m) => m.MainLayout),
    loadChildren: () => import('./features/features.routes').then((m) => m.featureRoutes),
  },

  {
    path: '**',
    redirectTo: '/not-found',
  },
];
